<template>
  <main v-scroll="scrollUpdate">
    <!-- キービジュアル -->
    <section id="keyvisual">
      <div class="attention">
        <div class="box">
          <p class="headline"><strong>重要なお知らせ</strong></p>
          <p class="body">本サービスは新規受付を終了しており、<br>2026年12月31日をもって<wbr>サービス提供を終了いたします。</p>
        </div>
      </div>
      <h1>
        <picture>
          <source media="(min-width: 768px)" type="" srcset="/assets/images/mojiko_top.svg">
          <img src="/assets/images/mojiko_top_mobile.svg" alt="もじこ">
        </picture>
      </h1>
      <p>AI音声認識を使った<span class="smbr"><br></span>文字起こしエディタ「もじこ」</p>
    </section>

    <!-- 製品概要 -->
    <section id="overview" class="content">
      <div class="container">
        <h2 class="flag line">製品概要</h2>
        <div class="wrapper">
          <div class="video_area">
            <div class="box">
              <iframe src="https://www.youtube.com/embed/videoseries?list=PLTcPP8N0YOp4kHoc4tmRIIM300yStowJs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div>
        <div class="wrapper">
          <div class="box">
            <h3>使いやすいエディター機能</h3>
            <figure><img src="/assets/images/overview1.svg" alt=""></figure>
            <p>タイムコードとの連携、メモの挿入機能、サムネイル画像で確認したり、話者設定など放送現場の声を取り入れた便利な機能が盛りだくさん。</p>
          </div>
          <div class="box">
            <h3>世界125か国語以上に対応</h3>
            <figure><img src="/assets/images/overview2.svg" alt=""></figure>
            <p>世界125か国以上の言語に対応、日本語以外のインタビューや音声・動画も、簡単に文字起こしが可能です。</p>
          </div>
          <div class="box">
            <h3>エンジンが選べる</h3>
            <figure><img src="/assets/images/overview3.svg" alt=""></figure>
            <p>GoogleやAmiVoice®（アドバンスト・メディア社）等、大手の音声認識エンジンを自由に選択することが可能です。</p>
          </div>
          <div class="box atokara">
            <h3>複数まとめての<span class="smbr"><br></span>文字起こしにも対応</h3>
            <figure><img src="/assets/images/overview4.svg" alt=""></figure>
            <p>ご要望の多かった複数ファイルにも対応し、「まとめて・アトカラ」文字起こしが可能になりました。<br>話者を特定する機能も搭載し、録音データをまとめて文字起こしが可能です。</p>
          </div>
          <div class="box">
            <h3>製品メリット</h3>
            <figure>
              <picture>
                <img src="/assets/images/feature.png" alt="もじこの特徴">
              </picture>
            </figure>
            <p>放送局では日々、多くの文字起こしが行われています。文字起こしは地獄です。この地獄に立ち向かうために「もじこ」は作られました。「もじこ」はあなたに寄り添いながら文字起こしのお手伝いをします。「もじこ」はあなたと一緒に未来の働き方を変えていきます。</p>
          </div>
        </div>
      </div>
    </section>
    <!-- ニュース -->
    <section id="news" class="content">
      <div class="container">
        <h2 class="belt">NEWS</h2>
        <div class="wrapper">
          <ul>
            <!-- template -------------
            <li>
              <p><a href="">「もじこ」はじめました</a></p>
              <p class="date">2020/00/00</p>
            </li>
            ＊wordpress側の設定でタイトルがクリックされた時の挙動を変えています
            --------------------------->
            <li v-for="post in news" :key="post.postId">
              <template v-if="post.exLink">
                <p v-if="post.exLink.type === 'none'">{{ post.title }}</p>
                <router-link v-else-if="post.exLink.type === 'detail'" :to="`/${post.categories.nodes[0].slug}/${post.postId}`">{{ post.title }}</router-link>
                <router-link v-else-if="post.exLink.type === 'inner'" :to="post.exLink.url">{{ post.title }}</router-link>
                <a v-else-if="post.exLink.type === 'outer'" :href="post.exLink.url" target="_blank" rel="noopener">{{ post.title }}</a>
                <a v-else-if="post.exLink.type === 'download'" :href="post.exLink.url" download>{{ post.title }}</a>
              </template>
              <template v-else>
                <p>{{ post.title }}</p>
              </template>
              <p class="date">{{ getFormatDate( post.date ) }}</p>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 活用事例 -->
    <section id="examples" class="content">
      <div class="container">
        <h2 class="flag line">活用事例</h2>
      </div>
      <!-- 活用事例 -->
      <div class="slider" v-if="examples">
        <div v-for="post in examples" :key="post.postId" class="examples">
          <div class="thumb" v-if="post.featuredImage"><router-link :to="`/${post.categories.nodes[0].slug}/${post.postId}`"><img :src="`${post.featuredImage.node.mediaItemUrl}`" alt=""></router-link></div>
          <p class="title">{{post.title}}</p>
          <p class="summary">{{post.cf_examples_summary.summary}}</p>
          <p class="readmore"><router-link :to="`/${post.categories.nodes[0].slug}/${post.postId}`">＞詳しく見る</router-link></p>
        </div>
      </div>
      <div class="container">
        <div class="wrapper">
          <h3>導入企業</h3>
          <ul>
            <li v-for="logo in introductions" :key="logo.alt"><a :href="logo.href" rel="nooepner" target="_blank"><img :src="`/assets/images/${logo.src}`" :alt="logo.alt"></a></li>
          </ul>
        </div>
      </div>
    </section>
    <!-- 価格 -->
    <section id="price" class="content">
      <div class="container">
        <h2 class="flag line">価格</h2>
        <table>
          <tr>
            <th></th>
            <th>価格</th>
          </tr>
          <tr>
            <th>初期費用</th>
            <td>無料</td>
          </tr>
          <tr>
            <th>月額基本料金</th>
            <td>15,000円 / 月</td>
          </tr>
          <tr>
            <th>文字起こし料金</th>
            <td>25円 / 分 <br><span>（文字起こしを行う素材の長さによる従量課金）</span></td>
          </tr>
        </table>
        <p class="commentary">※税抜での価格になります</p>
      </div>
    </section>
    <!-- FAQ -->
    <section id="faq" class="content">
      <div class="container">
        <h2 class="flag line">FAQ</h2>
        <h3>よくあるご質問</h3>
        <div class="wrapper">
          <p>「もじこ」について、必要な環境や料金体系についてなど、<span class="pcbr"><br></span>詳しくは下記リンク先にてお答えしております。</p>
          <div class="button"><router-link to="/faq/">詳しくはこちら</router-link></div>
          <figure><img src="/assets/images/faq.svg" alt="FAQ"></figure>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// import ModalVideo from '@/components/modal/Video.vue';
// import getNewArrivalsGql from '../apollo/queries/getNewArrivals.gql'
import getPostsByCategoryNameGql from '../apollo/queries/getPostsByCategoryName.gql'
// import introductions from '../../public/assets/js/introductions.js'

export default {
  components: {
    // 'modal-video': ModalVideo,
  },
  data() {
    return {
      modal: false,
      posts: [],
      introductions: INTRODUCTIONS, // eslint-disable-line
    };
  },
  mounted() {
    this.scrollUpdate()
  },
  methods: {
    scrollUpdate() {
      const wh = window.innerHeight - 200
      document.querySelectorAll('.content').forEach((content) => {
        if(content.getBoundingClientRect().top < wh) {
          content.classList.add('on')
        }
      })
    },
  },
  watch: {
    modal () {
      if (this.modal) {
        document.documentElement.style.overflow = 'hidden'
        return
      }
      document.documentElement.style.overflow = 'auto'
    },
  },
  computed: {
    news() {
      const news = this.posts.filter(post => post.categories.nodes[0].slug === 'news')
      return news.slice(0, 5)
    },
    examples() {
      const examples = this.posts.filter(post => post.categories.nodes[0].slug === 'examples')
      return examples
    },
  },
  apollo: {
    posts: {
      query: getPostsByCategoryNameGql,
      update: data => data.posts.nodes,
      variables () {
        return {
          categorySlug: 'news,examples',
        }
      },
    }
  }
}

</script>

<style lang="stylus">

</style>